import { DateTimeBox, DateTimeBoxLayoutStyle } from '@apply/components';
import { useState } from 'react';
import { DemoExample, DemoPage, DemoPageSection } from './common/DemoLayout';

export const DateTimeBoxDemo: React.FC = () => {
    const [dateBoxWithTime, set_dateBoxWithTime] = useState<string>('');
    const [dateBoxWithoutTime, set_dateBoxWithoutTime] = useState<string>('');
    const [dateBoxWithoutTimeWithBubble, set_dateBoxWithoutTimeWithBubble] = useState<string>('');
    const [dateBoxWithoutTimeHorizontal, set_dateBoxWithoutTimeHorizontal] = useState<string>('');
    const [dateBoxWithoutTimeWithBubbleHorizontal, set_dateBoxWithoutTimeWithBubbleHorizontal] = useState<string>('');

    return (
        <DemoPage title='Date Time Box :'>
            <DemoPageSection title='Vertical'>
                <DemoExample>
                    <DateTimeBox
                        required={true}
                        value={dateBoxWithTime}
                        onChange={(value) => set_dateBoxWithTime(value)}
                        label='DateTimeBox Showing Time'
                        includeTime={true}
                        width='250px'
                    />
                </DemoExample>
                <DemoExample>
                    <DateTimeBox
                        required={true}
                        value={dateBoxWithoutTime}
                        onChange={(value) => set_dateBoxWithoutTime(value)}
                        label='DateTimeBox Without Time'
                        includeTime={false}
                        width='250px'
                    />
                </DemoExample>
                <DemoExample>
                    <DateTimeBox
                        required={true}
                        value={dateBoxWithoutTimeWithBubble}
                        onChange={(value) => set_dateBoxWithoutTimeWithBubble(value)}
                        label='DateTimeBox Without Time With Bubble'
                        includeTime={false}
                        showInfoIcon={true}
                        infoText='DateTimeBox Without Time With Bubble'
                        width='250px'
                    />
                </DemoExample>
            </DemoPageSection>
            <DemoPageSection title='Horizontal'>
                <DemoExample>
                    <DateTimeBox
                        required={true}
                        value={dateBoxWithoutTimeHorizontal}
                        onChange={(value) => set_dateBoxWithoutTimeHorizontal(value)}
                        label='DateTimeBox Without Time (Horiz.)'
                        includeTime={false}
                        showInfoIcon={false}
                        infoText='DateTimeBox Without Time (Horiz.)'
                        width='200px'
                        layoutStyle={DateTimeBoxLayoutStyle.Horizontal}
                        labelWidth='auto'
                    />
                </DemoExample>
                <DemoExample>
                    <DateTimeBox
                        required={true}
                        value={dateBoxWithoutTimeWithBubbleHorizontal}
                        onChange={(value) => set_dateBoxWithoutTimeWithBubbleHorizontal(value)}
                        label='DateTimeBox Without Time With Bubble (Horiz.)'
                        includeTime={false}
                        showInfoIcon={true}
                        infoText='DateTimeBox Without Time With Bubble (Horiz.)'
                        width='200px'
                        layoutStyle={DateTimeBoxLayoutStyle.Horizontal}
                        labelWidth='auto'
                    />
                </DemoExample>
            </DemoPageSection>
        </DemoPage>
    );
};
